// @flow
import { useContext } from 'react';
import {
  ENABLED_FEATURES_BACKEND_NAME,
  TABLEFLOW_V2_FEATURE_KEY,
  TABLEFLOW_VERSIONS,
} from '@src/constants';

import { EstimateContext } from '../contexts/EstimateContext';

// The only interpretation of the estimate's Tableflow flag. Nothing else reads
// enabled_features, so every consumer agrees on the version.
export const getTableflowVersion = (estimate) =>
  estimate?.inputs?.[ENABLED_FEATURES_BACKEND_NAME]?.[TABLEFLOW_V2_FEATURE_KEY] === true
    ? TABLEFLOW_VERSIONS.V2
    : TABLEFLOW_VERSIONS.LEGACY;

export const useTableflowVersion = () => {
  const estimate = useContext(EstimateContext);
  return getTableflowVersion(estimate);
};
